export default __webpack_public_path__ + "static/char-v-30-90b452647452890ade25ae0ca9f9ca2b.webp";